import { AccommodationPlaceRoomBlockStatus, AccommodationPlaceType } from '@graphql/generated';
import { AccommodationCombinedType, AccommodationPlacesV2 } from './Accommodation.types';
import { isNull } from 'lodash-es';
interface AccommodationTypeArgs {
  type?: AccommodationPlaceType | null;
  customUrl?: string | null;
  zhId?: string | null;
  accommodationsSidebarUpdateExperimentEnabled: boolean;
}
const transformToAccommodationType = ({ type, customUrl, zhId, accommodationsSidebarUpdateExperimentEnabled }: AccommodationTypeArgs) => {
  if (accommodationsSidebarUpdateExperimentEnabled) {
    return customUrl || !zhId ? AccommodationCombinedType.Custom : AccommodationCombinedType.Hotel;
  }
  return type === AccommodationPlaceType.hotel ? AccommodationCombinedType.Hotel : AccommodationCombinedType.Custom;
};

export const AccommodationPlacesV2ToAccommodationCombined = (accommodationPlacesV2: AccommodationPlacesV2, accommodationsSidebarUpdateExperimentEnabled: boolean) => {
  const isRoomBlock = !isNull(accommodationPlacesV2?.accommodationRoomBlock) && accommodationPlacesV2?.accommodationRoomBlock?.status === AccommodationPlaceRoomBlockStatus.active;
  return {
    id: accommodationPlacesV2.id,
    type: isRoomBlock
      ? AccommodationCombinedType.Roomblock
      : transformToAccommodationType({
          type: accommodationPlacesV2.type,
          customUrl: accommodationPlacesV2.customUrl,
          zhId: accommodationPlacesV2.zhId,
          accommodationsSidebarUpdateExperimentEnabled
        }),

    //   General Information
    displayName: accommodationPlacesV2?.customName || accommodationPlacesV2?.name,
    address: accommodationPlacesV2?.customAddress || accommodationPlacesV2?.address,
    customAddress: accommodationPlacesV2?.customAddress,
    city: accommodationPlacesV2?.city,
    country: accommodationPlacesV2?.country,
    state: accommodationPlacesV2?.state,
    postalCode: accommodationPlacesV2?.postalCode,
    latitude: accommodationPlacesV2?.lat,
    longitude: accommodationPlacesV2?.long,

    description: accommodationPlacesV2.userNote,
    email: accommodationPlacesV2?.email,
    phone: accommodationPlacesV2?.customPhone || accommodationPlacesV2?.phone,
    url: accommodationPlacesV2?.customUrl || accommodationPlacesV2?.url,
    customUrl: accommodationPlacesV2?.customUrl,

    // JoyPlaceID
    joyPlaceId: accommodationPlacesV2?.joyPlaceId,

    //   Provider Information
    googlePlaceId: accommodationPlacesV2?.googlePlaceId,
    zhId: accommodationPlacesV2?.zhId,

    //   Extra Information
    pricePerNight: isRoomBlock ? accommodationPlacesV2.accommodationRoomBlock?.pricePerNight : undefined,
    bookingUrl: isRoomBlock ? accommodationPlacesV2.accommodationRoomBlock?.bookingUrl : undefined,
    cutoffDate: isRoomBlock ? accommodationPlacesV2.accommodationRoomBlock?.cutoffDate : undefined,
    checkOutDate: isRoomBlock ? accommodationPlacesV2.accommodationRoomBlock?.checkOutDate : undefined,
    checkInDate: isRoomBlock ? accommodationPlacesV2.accommodationRoomBlock?.checkInDate : undefined,
    strikeoutPricePerNight: isRoomBlock ? accommodationPlacesV2.accommodationRoomBlock?.strikeoutPricePerNight : undefined,
    numberOfRoomsReserved: isRoomBlock ? accommodationPlacesV2.accommodationRoomBlock?.numberOfRoomsReserved : undefined,

    //   Custom Properties
    isFavorite: accommodationPlacesV2?.isFavorite,
    starRating: undefined,

    photo: accommodationPlacesV2.isPhotoHidden ? null : accommodationPlacesV2.customPhoto || accommodationPlacesV2.photo,
    isFromAccommodationCatalog: accommodationPlacesV2.isFromAccommodationCatalog
  };
};
